import { Subscription, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserPageService {
  formChangesSubscription: Subscription;
  statusChangeSubScriptionSubjectStep = new BehaviorSubject<number>(1);
  formIsDirtySubject = new BehaviorSubject<{ dirty: boolean, formNumber: number }>({ dirty: false, formNumber: 1 });

  constructor() { }

}
